import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {InnerSummary} from '../../inner-summary'
import {StyledButton} from '../../styled-button'
import {SummaryContainer} from '../../summary-container'
import {FooterProps} from './index'

export const Footer = ({
  placesInBasketCount,
  invoice,
  showAccessibilityMode,
  setShowAccessibilityMode,
  onButtonClick,
}: FooterProps) => {
  const {t} = useTranslation()
  const handleButtonClick = () => (onButtonClick ? onButtonClick() : setShowAccessibilityMode(false))

  return (
    <SummaryContainer inAccessibilityMode={showAccessibilityMode}>
      <InnerSummary invoice={invoice} selectedTicketsQuantity={placesInBasketCount} withoutBreakdown />
      <StyledButton onClick={handleButtonClick} dataHook={DH.VIEW_BASKET}>
        {t('seatings_viewBasket')}
      </StyledButton>
    </SummaryContainer>
  )
}
